module.exports = __webpack_public_path__ + "media/images/pic/home/owners-d1013b95fd6761d119210b21e6bb9e37.svg";